export default "__VITE_ASSET__51e0ec7f__"